import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group d-flex flex-wrap" }
const _hoisted_15 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "el-form-item__content" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group d-flex flex-wrap" }
const _hoisted_25 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group d-flex flex-wrap" }
const _hoisted_28 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group d-flex flex-wrap" }
const _hoisted_31 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group d-flex flex-wrap" }
const _hoisted_34 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_37 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_38 = { class: "indicator-label" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_40 = { class: "indicator-progress" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_42 = { class: "card mb-5 mb-xl-10" }
const _hoisted_43 = { class: "card-header" }
const _hoisted_44 = { class: "card-title m-0" }
const _hoisted_45 = { class: "fw-boldest m-0" }
const _hoisted_46 = { class: "card-body p-9" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group d-flex flex-wrap" }
const _hoisted_56 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_59 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_60 = { class: "indicator-label" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_62 = { class: "indicator-progress" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("stockOut.id")), 1),
                _createVNode(_component_el_form_item, { prop: "stock_out_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.stock_out_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.stock_out_id) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("stockOut.stockOutTime")), 1),
                _createVNode(_component_el_form_item, { prop: "stock_out_time" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.stock_out_time,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.stock_out_time) = $event)),
                      type: "date",
                      style: {"width":"100%"},
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("stockOut.warehouse")), 1),
                _createVNode(_component_el_form_item, { prop: "warehouse_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.warehouse_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.warehouse_id) = $event)),
                      clearable: "",
                      style: {"width":"100%"},
                      disabled: "",
                      placeholder: " "
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("stockOut.status")), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.statusClass(_ctx.formData.status)])
                  }, _toDisplayString(_ctx.formData.__show.status), 3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("stockOut.stockOutType")), 1),
                _createVNode(_component_el_form_item, { prop: "stock_out_type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.stock_out_type,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.stock_out_type) = $event)),
                      clearable: "",
                      style: {"width":"100%"},
                      disabled: "",
                      placeholder: " "
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.stock_out_type, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("order.skuIdentifier")), 1),
                _createVNode(_component_el_form_item, { prop: "sku_identifier" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.sku_identifier,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.sku_identifier) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("stockOut.targetQuantity")), 1),
                _createVNode(_component_el_form_item, { prop: "target_quantity" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.target_quantity,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.target_quantity) = $event)),
                      type: "number",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("stockOut.actualQuantity")), 1),
                _createVNode(_component_el_form_item, { prop: "actual_quantity" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.actual_quantity,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.actual_quantity) = $event)),
                      type: "number",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("stockOut.exceptionStatus")), 1),
                _createVNode(_component_el_form_item, { prop: "exception_status" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.formData.exception_status,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.exception_status) = $event)),
                      "active-value": 1,
                      "inactive-value": 0,
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_36,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_37, [
            _createElementVNode("span", _hoisted_38, [
              _hoisted_39,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_40, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_41
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.t("stockOut.relatedActivities")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("stockOut.nextShipment")), 1),
                _createVNode(_component_el_form_item, { prop: "next_shipment_tracking_no" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.next_shipment_tracking_no,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.next_shipment_tracking_no) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("order.relatedSalesOrder")), 1),
                _createVNode(_component_el_form_item, { prop: "related_sales_order" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.sale_order_number,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.sale_order_number) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("order.relatedFulfilmentOrder")), 1),
                _createVNode(_component_el_form_item, { prop: "related_fulfillment_order" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.fulfillment_order_number,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.fulfillment_order_number) = $event)),
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_58,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, [
              _hoisted_61,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_62, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_63
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}